<template lang="pug">
    div
        grid-table-component(
            :headers="headers"
            :data="data"
            :is-paginated="true"
            :is-loading="isLoading"
            :pagination="setPagination()"
            @table:page-changed="checkPaginationChange($event)"
            :enableMultiSelect="false"
        )
            template(v-slot:nome="{ item }")
                i(:class="item.icon")
                span {{ item.nomeUsuario }}

            template(v-slot:totalProcessos="{ item }")
                span {{ item.totalProcessos || '0' }}   


            template(v-slot:acoes="{ item }")
                div.actions-check(v-if="item.totalProcessos > 0")
                    dropdown-component(
                        :list="montarAcoes(item)"
                        @input="onAction($event, item)"
                        :props="{ label: 'nome' }"
                        :is-select="false"
                        position="left"
                    )         

</template>

<script>
export default {
    name: 'MigracaoProcesso',

    props: {
        headers: {
            type: Array,
            default: () => [
                { text: 'Gerente Operacional', value: 'nome' },                
                { text: 'Total', value: 'totalProcessos' },
                { text: 'Ações', value: 'acoes' },
            ],
        },

        data: {
            type: Array,
            default: () => [],
        },

        paginacao: {
            type: Object,
            default: () => ({
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                processos: {},
            }),
        },

        isLoading: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        checkPaginationChange(page) {        
            this.$emit('table:page-changed', page); 
        },

        setPagination() {
            const pagination = {
                page: this.paginacao.pagina,
                totalPages: this.paginacao.numeroPaginas,
                itemsPerPage: this.paginacao.quantidadePagina,
                totalItems: this.paginacao.total,
                order: 'ASC',
            };            
            return pagination;
        },

        montarAcoes() {
            const acoes = [];
           
            acoes.push(
                { nome: 'Visualizar Processos', id: 'visualizar', icon: 'mdi-eye' },
                { nome: 'Migrar Processos', id: 'migrar', icon: 'mdi-file-swap' }
            );
            

            return acoes;
        },

        async onAction(event, item) {
            try {
                switch (event.id) {
                    case 'visualizar':
                        this.$emit('action:visualizar', item);
                        break;
                    case 'migrar':
                        this.$emit('action:migrar', item);
                        break;                    
                    default:
                        break;
                }
            } catch (error) {
                this.$toast({
                    showClose: true,
                    message: 'Erro ao executar ação: ' + JSON.stringify(error),
                    type: 'error'
                });                
            }
        },
    },
};
</script>

<style lang="scss" scoped>
/* styles.css */
.chip {
    width: 120px;    
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;    
    color:white;    
}

.actions-check button {
    display: flex;
    align-items: center;
    border: none;
    background: none;
    cursor: pointer;
    padding: 5px;
    font-size: 14px;
    color: var(--primary-blue);

    i {
        margin-right: 5px;
    }

    &:hover {
        color: var(--primary-dark-blue);
    }
}
</style>